namespace MACRAIL.Validation {

/**
 * Easy validation for form fields.
 */
export class CustomFunctionValidator implements IValidator {

    private opts: any;

    constructor (opts: any) {

        if (typeof opts === 'function') {
            opts = {
                'callback': opts,
            };
        }

        opts.extraData = opts.extraData || {};

        this.opts = opts;
    }

    public validate(value: any) {
        let opts = this.opts;

        let messages: IValidatorMessage[] = [];

        function addMessage(status: ValidationStatus, message: string) {
            messages.push({
                'slug': 'custom',
                'status': status,
                'message': message,
            });
        }
        this.opts.callback(value, addMessage, this.opts.extraData);

        return messages;
    }
}

}
